import { AuthStateType } from "Contexts/Auth";

const AuthStorageName = "auth-state";

export const setAuthStorage = (authState: AuthStateType) => {
  try {
    localStorage.setItem(AuthStorageName, JSON.stringify(authState));
  } catch (error) {
    console.log(error);
  }
};
export const clearAuthStorage = () => {
  localStorage.removeItem(AuthStorageName);
};
const authInitialProps: AuthStateType = {
  isLoggedIn: false,
  name: "",
  role: undefined,
};
export const getAuthStorage = (): AuthStateType => {
  const authStorage = localStorage.getItem(AuthStorageName);
  return authStorage ? JSON.parse(authStorage) : authInitialProps;
};
